<template>
  <b-col cols="4">
    <b-card
      class="earnings-card"
    >
      <!-- <b-row> -->

          <b-card-title class="mb-1">
            MyScoreIQ
          </b-card-title>
          <div class="row">
            <b-col cols="12">
              <div class="font-small-2">
                Active Report
              </div>
              <h5 class="mb-1">
                {{data.MyScoreIQ}}
              </h5>
            </b-col>
          </div>

      <!-- </b-row> -->
    </b-card>
  </b-col>
</template>

<script>
import {
  BCard, BRow, BCol
} from 'bootstrap-vue-3'
export default {
  name:'MyScoreIqComponent',
  components: {
    BCard,
    BRow,
    BCol
  },
  props: {
      data: {
        type: Object,
        default: () => {},
      },
  },
  data() {
    return {

    }
  },
}
</script>
